import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  SelectItem,
  ErrorItem,
} from "../../../../Components/Items";
import { TIPO_PERSONAL_OPTIONS } from "../../../../constants/nomina/repse";

const { Option } = Select;

class AgregarPuesto extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (values?.nombre) {
      this.setState({ loading: true });
      axios
        .post(
          "puestos/agregarPuesto",
          {
            ...values,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Puesto agregado exitosamente");
            this.cerrarModal();
          } else if (res.data.success === 1) {
            message.error("No se pudo agregar el puesto");
          } else {
            message.error("Sucedió un error y no se pudo agregar el puesto");
          }
        })
        .catch(() => {
          this.setState({ loading: false });
          message.error("Error al comunicarse con el servidor");
        });
    } else {
      message.info("Proporcione al menos el nombre del puesto");
    }
  }

  cerrarModal = () => {
    this.setState({ visible: false });
    this.props.cerrarAgregarPuesto();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Agregar Puesto"
        visible={this.state.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={600}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarPuesto"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="nombre"
            label="Nombre"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre del puesto" />
          </FormItem>

          <FormItem
            name="tipoPersonal"
            label="Tipo de Personal"
            margin
          >
            <SelectItem placeholder="Tipo de personal (REPSE)" allowClear>
              {TIPO_PERSONAL_OPTIONS.map((value) => (
                <Option value={value} key={value}>
                  {value}
                </Option>
              ))}
            </SelectItem>
          </FormItem>

          <FormItem
            name="descripcion"
            label="Descripción"
            margin
          >
            <InputItem placeholder="Ingresa la descripción del puesto" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarPuesto);